import "@ramudden/core/extensions";
import "hammerjs";
import "prismjs";
import "prismjs/components/prism-csharp";
import "prismjs/components/prism-json";

import "@angular/common/locales/global/de";
import "@angular/common/locales/global/en";
import "@angular/common/locales/global/fr";
import "@angular/common/locales/global/nl";
import "@angular/common/locales/global/no";
import "@angular/common/locales/global/sv";
import { ApplicationRef, enableProdMode } from "@angular/core";
import { enableDebugTools } from "@angular/platform-browser";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then((moduleRef) => {
        if (!environment.production) {
            const applicationRef = moduleRef.injector.get(ApplicationRef);
            const componentRef = applicationRef.components[0];

            // allows to run `ng.profiler.timeChangeDetection();`
            enableDebugTools(componentRef);
        }
    })
    .catch((err) => console.error(err));
